import "./EquipmentDetails.html";

import "./EditCommunicationConfiguration/EditCommunicationConfigurationComponent";
import "./EditCredentials/EditEquipmentCredentialsComponent";
import "./EditDirectConnections/CreateDirectConnectionComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EquipmentDetailsComponentController from "./EquipmentDetailsComponentController";

export default class EquipmentDetailsComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            isSidebarCollapsed: "<",
            siteEquipment: "<",
            isEditable: "<",
        };
        this.controller = EquipmentDetailsComponentController;
        this.templateUrl =
            "/App/Components/Site/DesignAndPlanning/SelectedEquipment/EquipmentDetails/EquipmentDetails.html";
    }
}

module("mmManagePortal").component("irEquipmentDetails", new EquipmentDetailsComponent());
